import { FC, useEffect, useRef } from 'react'
import { InfoAlert } from '../../../../../../components'
import { ErroExameImagem } from './erros'
import styles from './ExamesImagem.module.css'

/** Recebe o foco a cada erro novo: o botão que disparou a ação fica desabilitado ou some. */
export const ErroExameImagemAlerta: FC<{ erro: ErroExameImagem }> = ({ erro }) => {
  const ref = useRef<HTMLDivElement>(null)
  useEffect(() => {
    ref.current?.focus()
  }, [erro])
  return (
    <div ref={ref} tabIndex={-1} className={styles.alvoFoco}>
      <InfoAlert variant='danger' role='alert' size='sm' title={erro.mensagem}>
        {erro.detalhe}
      </InfoAlert>
    </div>
  )
}
